__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "userhub";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@reduxjs/toolkit", "2.8.2", () => (Promise.all([__webpack_require__.e(3313), __webpack_require__.e(4929)]).then(() => (() => (__webpack_require__(3313))))));
			register("@salesforce/design-system-react", "0.10.63", () => (Promise.all([__webpack_require__.e(5676), __webpack_require__.e(4914), __webpack_require__.e(6672), __webpack_require__.e(5819)]).then(() => (() => (__webpack_require__(5676))))));
			register("axios", "1.13.5", () => (__webpack_require__.e(8225).then(() => (() => (__webpack_require__(8225))))));
			register("date-fns", "4.1.0", () => (__webpack_require__.e(5959).then(() => (() => (__webpack_require__(5959))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__(961))))));
			register("react-redux", "9.2.0", () => (Promise.all([__webpack_require__.e(5135), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__(5135))))));
			register("react-router-dom", "6.30.3", () => (Promise.all([__webpack_require__.e(2648), __webpack_require__.e(4914), __webpack_require__.e(6672)]).then(() => (() => (__webpack_require__(2648))))));
			register("react", "17.0.2", () => (__webpack_require__.e(8543).then(() => (() => (__webpack_require__(8543))))));
			register("react", "18.3.1", () => (__webpack_require__.e(4159).then(() => (() => (__webpack_require__(6540))))));
			register("redux-persist-transform-encrypt", "5.1.1", () => (Promise.all([__webpack_require__.e(4039), __webpack_require__.e(6540), __webpack_require__.e(477)]).then(() => (() => (__webpack_require__(4039))))));
			register("redux-persist", "6.0.0", () => (Promise.all([__webpack_require__.e(1385), __webpack_require__.e(4929)]).then(() => (() => (__webpack_require__(1385))))));
			register("redux", "5.0.1", () => (__webpack_require__.e(3079).then(() => (() => (__webpack_require__(3079))))));
			register("uuid", "9.0.1", () => (__webpack_require__.e(9308).then(() => (() => (__webpack_require__(9308))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};